export interface SubjectPayload {
    IDFaecher: number
    FachName: string
    fachkuerzel: string
    schrPruefung: number
    status: number
    assessable: boolean
    STP_Kurz: string
    is_elective: boolean
    description: string
    consider_absents: boolean
    for_social_grades: boolean
}

export const STATUS_ACTIVE = 0;

export const STATUS_DEACTIVATED = 1;

export class Subject {

    IDFaecher: number
    FachName: string
    fachkuerzel: string
    schrPruefung: number
    status: number
    assessable: boolean
    STP_Kurz: string
    is_elective: boolean
    description: string
    consider_absents: boolean
    for_social_grades: boolean

    constructor(data: SubjectPayload) {
        this.IDFaecher = data.IDFaecher
        this.FachName = data.FachName
        this.fachkuerzel = data.fachkuerzel
        this.schrPruefung = data.schrPruefung ? data.schrPruefung : 0
        this.status = data.status
        this.assessable = data.assessable ? data.assessable : true
        this.STP_Kurz = data.STP_Kurz
        this.is_elective = data.is_elective
        this.description = data.description
        this.consider_absents = data.consider_absents ? data.consider_absents : true
        this.for_social_grades = data.for_social_grades
    }

    fill(data: SubjectPayload): this {
        this.IDFaecher = data.IDFaecher
        this.FachName = data.FachName
        this.fachkuerzel = data.fachkuerzel
        this.schrPruefung = data.schrPruefung
        this.status = data.status
        this.assessable = data.assessable
        this.STP_Kurz = data.STP_Kurz
        this.is_elective = data.is_elective
        this.description = data.description
        this.consider_absents = data.consider_absents
        this.for_social_grades = data.for_social_grades
        return this
    }

    payload(): SubjectPayload {
        return {
            IDFaecher: this.IDFaecher,
            FachName: this.FachName,
            fachkuerzel: this.fachkuerzel,
            schrPruefung: this.schrPruefung,
            status: this.status,
            assessable: this.assessable,
            STP_Kurz: this.STP_Kurz,
            is_elective: this.is_elective,
            description: this.description,
            consider_absents: this.consider_absents,
            for_social_grades: this.for_social_grades
        }
    }
}
